/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MessageResponse } from '../models/MessageResponse';
import type { MunicipalityResponse } from '../models/MunicipalityResponse';
import type { MunicipalityStatsResponse } from '../models/MunicipalityStatsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class MunicipalityDashboardService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get active reports within jurisdiction (map view)
     * Returns neighboring reports within the municipality's assigned communes that are active at a given point in time. Reports are active when createdAt <= cursor AND (expiresAt >= cursor OR isOfficial = true). Official municipal reports never expire.
     * @returns any List of active reports within jurisdiction.
     * @throws ApiError
     */
    public municipalityDashboardControllerGetActiveMapReports({
        page = 1,
        limit = 20,
        cursor,
        type,
    }: {
        /**
         * Page number
         */
        page?: number,
        /**
         * Items per page (max 200)
         */
        limit?: number,
        /**
         * ISO 8601 datetime for timeline filtering. Defaults to now().
         */
        cursor?: string,
        /**
         * Filter by report type
         */
        type?: 'SUSPECT_INDIVIDUAL' | 'SUSPICIOUS_VEHICLE' | 'INTRUSION_ATTEMPT' | 'BURGLARY' | 'SPYING_AND_TRACKING' | 'OTHER',
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/municipality/map-reports/active',
            query: {
                'page': page,
                'limit': limit,
                'cursor': cursor,
                'type': type,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Municipality role required.`,
            },
        });
    }
    /**
     * Get reports within jurisdiction by creation date (map view)
     * Returns neighboring reports within the municipality's assigned communes filtered by creation date range. Use createdAtFrom and createdAtTo to query reports created within a specific time window.
     * @returns any List of reports within jurisdiction filtered by creation date.
     * @throws ApiError
     */
    public municipalityDashboardControllerGetMapReportsByCreatedAt({
        page = 1,
        limit = 20,
        createdAtFrom,
        createdAtTo,
        type,
    }: {
        /**
         * Page number
         */
        page?: number,
        /**
         * Items per page (max 200)
         */
        limit?: number,
        /**
         * ISO 8601 datetime lower bound. Only reports created at or after this date are returned.
         */
        createdAtFrom?: string,
        /**
         * ISO 8601 datetime upper bound. Only reports created at or before this date are returned.
         */
        createdAtTo?: string,
        /**
         * Filter by report type
         */
        type?: 'SUSPECT_INDIVIDUAL' | 'SUSPICIOUS_VEHICLE' | 'INTRUSION_ATTEMPT' | 'BURGLARY' | 'SPYING_AND_TRACKING' | 'OTHER',
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/municipality/map-reports',
            query: {
                'page': page,
                'limit': limit,
                'createdAtFrom': createdAtFrom,
                'createdAtTo': createdAtTo,
                'type': type,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Municipality role required.`,
            },
        });
    }
    /**
     * Get municipality dashboard statistics
     * Returns aggregated statistics for the municipality's jurisdiction: total active reports, official vs citizen counts, and breakdown by report type.
     * @returns MunicipalityStatsResponse Dashboard statistics returned successfully.
     * @throws ApiError
     */
    public municipalityDashboardControllerGetDashboardStats(): CancelablePromise<MunicipalityStatsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/municipality/stats',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Municipality role required.`,
            },
        });
    }
    /**
     * Get own municipality profile
     * Returns the municipality profile with assigned communes for the authenticated municipality user.
     * @returns MunicipalityResponse Municipality profile returned successfully.
     * @throws ApiError
     */
    public municipalityDashboardControllerGetProfile(): CancelablePromise<MunicipalityResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/municipality/profile',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Municipality role required.`,
            },
        });
    }
    /**
     * Delete a report within jurisdiction
     * Deletes any neighboring report (citizen or official) that falls within the municipality's assigned communes. Used for content moderation.
     * @returns MessageResponse Report deleted successfully.
     * @throws ApiError
     */
    public municipalityDashboardControllerDeleteReport({
        id,
    }: {
        /**
         * Report unique identifier
         */
        id: string,
    }): CancelablePromise<MessageResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/municipality/reports/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Report not found or outside jurisdiction.`,
            },
        });
    }
}
